import request from './financeRequest'

export const organizationApi = {
  branches: () => request.get('/finance/branches'),
  createBranch: (data) => request.post('/finance/branches', data),
  updateBranch: (id, data) => request.put(`/finance/branches/${id}`, data),
  toggleBranch: (id, enabled) =>
    request.post(`/finance/branches/${id}/enabled`, null, {
      params: { enabled },
    }),
  employees: () => request.get('/finance/employees'),
  assignEmployee: (id, branchId) =>
    request.put(`/finance/employees/${id}/branch`, { branchId }),
  teams: () => request.get('/finance/teams'),
  createTeam: (data) => request.post('/finance/teams', data),
  updateTeam: (id, data) => request.put(`/finance/teams/${id}`, data),
  toggleTeam: (id, enabled) =>
    request.post(`/finance/teams/${id}/enabled`, null, {
      params: { enabled },
    }),
  addTeamMember: (id, data) =>
    request.post(`/finance/teams/${id}/members`, data),
  removeTeamMember: (id, memberId) =>
    request.delete(`/finance/teams/${id}/members/${memberId}`),
  paymentMethods: () => request.get('/finance/payment-methods'),
  createPaymentMethod: (data) => request.post('/finance/payment-methods', data),
  togglePaymentMethod: (id, enabled) =>
    request.post(`/finance/payment-methods/${id}/enabled`, null, {
      params: { enabled },
    }),
  profile: () => request.get('/finance/profile'),
  logs: (params) => request.get('/finance/logs', { params }),
  migration: (params) => request.get('/finance/migration', { params }),
  completeMigration: (id, note) =>
    request.post(`/finance/migration/${id}/complete`, { note }),
}
